import {EventApprover} from "../types/domain.ts";
import {isFirManager, isRegionManager} from "./userTypeGuards.ts";

export const groupByRegions = (approvers: EventApprover[]) => {
    return approvers.reduce((acc, entry) => {
        const user = entry.user;

        if (entry.reason === 'staff') {
            if (!acc["Стафф"]) acc["Стафф"] = [];
            acc["Стафф"].push(entry);
            return acc;
        }

        if(user && isRegionManager(user)) {
            const regionName = user.region.name;
            if (!acc[regionName]) acc[regionName] = [];
            acc[regionName].push(entry);
            return acc;
        }

        if(user && isFirManager(user)) {
            const uniqueRegions = Array.from(
                new Set(user.firs.map(fir => fir.region?.name).filter(Boolean))
            ) as string[];

            uniqueRegions.forEach(regionName => {
                if (!acc[regionName]) acc[regionName] = [];
                acc[regionName].push(entry);
            });
            return acc;
        }

        return acc;
    }, {} as Record<string, EventApprover[]>);
}